import SvgColor from 'src/components/svg-color';
import { Typography } from '@mui/material';
// ----------------------------------------------------------------------

const icon = (name, color = 'inherit') => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{
      width: 1,
      height: 1,
      color: color, // Set the desired color here
    }}
  />
);

const navConfig = [
  {
    title: <Typography color="#000000" fontWeight={700}>Dashboard</Typography>,
    path: '/',
    icon: icon('ic_analytics', "#8B19A4"),
  },
  {
    title: <Typography color="#000000" fontWeight={700}>Users</Typography>,
    path: '/user',
    icon: icon('ic_user', '#8B19A4'),
  },
  {
    title: <Typography color="#000000" fontWeight={700}>Logs</Typography>,
    path: '/logs',
    icon: icon('ic_user', '#8B19A4'),
  },
];

export default navConfig;
